import React from 'react'
import { Link } from 'react-router-dom'
import salemap from '../Components/images/salemap.png'

const Connect = () => {
    return (
        <>
            <div className="md:mx-2">

                <div className="py-10 md:border-t-2 md:mx-0 mx-2">
                    <h1 className='text-[#004A8B] text-[2.6rem] md:ml-[22rem] font-black'>Our offices</h1>
                    <div className=" border-b-[.4rem] border-b-[#B5D1B3] md:ml-[22rem] py-1  w-[4rem]"></div>
                </div>
                <div className="container-fluid md:mx-20 py-10">

                    <div className="">
                        <div class="grid grid-cols-12 mx-3 md:mx-0">

                            <div class="md:col-span-4 col-span-12 ">

                                <div className="w-full ">
                                    <h1 className='text-[#004A8B] text-[2rem]   font-black'>Victoria</h1>
                                    <a href="" className='text-[#004A8B]  text-[1.2rem]
                                    font-medium'>+61 3 8361 8110</a>
                                    <h1>Level 26/80 Collins Street, Melbourne VIC, Australia.</h1>
                                </div>

                                <div className="w-full py-5">
                                    <h1 className='text-[#004A8B] text-[2rem] font-black'>Queensland</h1>
                                    <a href="" className='text-[#004A8B]  text-[1.2rem] font-medium'>+61 7 3059 9520</a>
                                    <h1>The Annex, Suite 1.1, Level 1, 12 Creek Street, Brisbane Qld 4000.</h1>
                                </div>

                                <div className="w-full py-5 ">
                                    <h1 className='text-[#004A8B] text-[2rem] font-black'>New South Wales</h1>
                                    <a href="" className='text-[#004A8B] text-[1.2rem] font-medium'>+61 2 8354 5008</a>
                                    <h1>L5/100 Market Street, Sydney NSW 2000, Australia.</h1>
                                </div>

                                <div className="w-full py-5 ">
                                    <h1 className='text-[#004A8B] text-[2rem] font-black'>Western Australia</h1>
                                    <a href="" className='text-[#004A8B] text-[1.2rem] font-medium'>+61 8 6383 5399</a>
                                    <h1>Level 2/5 Ord Street, West Perth WA 6005, Australia.</h1>
                                </div>


                                <div className="   w-full text-md font-black py-2 ">
                                    <button>
                                        <Link to='/Contact' className='hover:text-[#B6D0B3] text-[#004A8B] flex text-[18px] font-black'> info@lawd.com.au</Link>
                                    </button>
                                </div>

                            </div>

                            <div class="md:col-span-8 col-span-12 py-10 md:my-0">
                                <div className="md:mx-0 mx-2">
                                    <img src={salemap} alt="map" className='md:h-[103vh] h-[60vh]  w-[100%] hover:opacity-70 hover:bg-gray-200 transition duration-500 ease-in-out sm:hover:bg-transparent sm:hover:opacity-100' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="conatiner-fluid bg8 bg-[#F1F2F2] mx-20">
                    <div className="py-10 md:mx-0 mx-2">
                        <h1 className='text-[#004A8B] text-[2.6rem] md:ml-[18rem] font-black'>Contact us</h1>
                        <div className=" border-b-[.4rem] border-b-[#B5D1B3] md:ml-[18rem] py-1  w-[4rem]"></div>

                        <div className="py-10 mx-3 md:mx-0">

                            <div className="grid grid-cols-12 py-5 md:px-[18rem] gap-8">

                                <input type="text" name="" id="" placeholder='FIRST NAME' className='border-b text-[12px] w-full md:col-span-6  col-span-12 tracking-wider border-b-[#B5D1B3] focus-border-[#B5D1B3] outline-none bg-[#F1F2F2] placeholder-black py-2' />

                                <input type="text" name="" id="" placeholder='SURE NAME' className='border-b text-[12px] md:col-span-6  col-span-12  tracking-wider border-b-[#B5D1B3] focus-border-[#B5D1B3] outline-none bg-[#F1F2F2] placeholder-black py-2' />

                            </div>

                            <div className="grid grid-cols-12 md:px-[18rem] gap-8">

                                <input type="text" name="" id="" placeholder='TELEPHONE' className='border-b text-[12px] w-full md:col-span-6  col-span-12 tracking-wider border-b-[#B5D1B3] focus-border-[#B5D1B3] outline-none bg-[#F1F2F2] placeholder-black py-2' />


                                <input type="text" name="" id="" placeholder='EMAIL' className='border-b text-[12px] md:col-span-6  col-span-12 tracking-wider border-b-[#B5D1B3] focus-border-[#B5D1B3] outline-none bg-[#F1F2F2] placeholder-black py-2' />

                            </div>

                            <div className="grid grid-cols-12 md:px-[18rem] py-10 ">
                                <textarea name="" placeholder='YOUR ENQUIRY' className='col-span-12  text-[13px] bg-[#F1F2F2] border-b border-b-[#B5D1B3] focus-border-[#B5D1B3] outline-none placeholder-black' id="" cols='10' rows='5'></textarea>
                            </div>
                            <div className='md:ml-[18rem] flex'>

                                <input type="radio" name="" id="" className='h-7 w-7 checked:ring-blue-500 rounded-full border-2 border-blue-500 checked:border-blue-500' />
                                <span className='mx-2 my-1 tracking-widest text-[14px]'>I accepted LAWD's <a href="" className=' underline hover:no-underline'>Privacy Policy</a></span>
                            </div>
                            <div className="md:ml-[18rem] my-10">
                                <button className='border text-[14px] md:mx-0 mx-4 px-8 tracking-wider py-2 bg-[#004A8B] border-[#004A8B] text-white hover:border-[#B5D1B3] hover:bg-[#B5D1B3] hover:text-[#004A8B]  '><Link>SUBMIT</Link></button>
                            </div>
                        </div>



                    </div>
                </div>
            </div>

        </>
    )
}

export default Connect
